export const AuditLogHttpPaths = {
  auditLog: (shiftId: number) => `/shifts/${shiftId}/audit-logs`,
} as const;
